import { computed } from 'vue';
import { SearchUserDto } from '@studyportals/campaign-management-api-interface';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class RightsCode {
	private rightsUsers = computed((): SearchUserDto[] => {
		return store.getters.rightsUsers();
	});

	public async mounted(): Promise<void> {
		await this.loadEssentialData();
		store.mutations.incrementLoadCount();
	}

	private async loadEssentialData(): Promise<void> {
		if (this.rightsUsers.value.length) {
			return;
		}

		await campaignPresenter.retrieveRightsUsers();
		campaignPresenter.updateOriginalCampaignData();
	}
}
